import { FileCollection } from './FileCollection';
export function groupFiles(fileCollection, options = {}) {
    const { groupBy = 'baseDir', meta } = options;
    const fileCollectionItems = fileCollection.files;
    let results = {};
    for (const file of fileCollectionItems) {
        const key = getKey(file, groupBy);
        if (!results[key]) {
            results[key] = {
                meta: getMeta(key, meta),
                key,
                fileCollectionItems: [],
            };
        }
        results[key].fileCollectionItems.push(file);
    }
    return Object.keys(results).map((key) => ({
        meta: results[key].meta,
        key,
        fileCollection: new FileCollection(results[key].fileCollectionItems),
    }));
}
function getMeta(key, meta) {
    if (!meta)
        return {};
    const matcher = key.match(meta);
    if (!matcher)
        return {};
    return matcher.groups || {};
}
function getKey(file, groupBy) {
    if (typeof groupBy === 'string') {
        const fileInfo = getFileInfo(file);
        switch (groupBy) {
            case 'baseDir':
                return fileInfo.baseDir;
            case 'extension':
                return fileInfo.extension;
            case 'filename':
                return fileInfo.filename;
            default:
                throw new Error(`Unknown groupBy strategy: ${String(groupBy)}`);
        }
    }
    else {
        return groupBy(file, getFileInfo(file));
    }
}
function getFileInfo(file) {
    return {
        baseDir: file.relativePath.replace(/\/[^/]*$/, ''),
        extension: file.relativePath.replace(/^.*\./, ''),
        filename: file.relativePath.replace(/^.*\//, '').replace(/.[^.]*$/, ''),
    };
}
//# sourceMappingURL=groupFiles.js.map